import React, { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import ProviderStore from 'store/Provider';
import SubscriptionStore from 'store/Subscription';
import CalendarManagePage from '../CalendarManagePage';
import { EKey, getHasShowCalendarOnboardingPopup240315, getHasShowCalendarOnboardingPopup240415, setHasShowCalendarOnboardingPopup240315, setHasShowCalendarOnboardingPopup240415 } from 'utils/localstore';
import WelcomeModal from './components/WelcomeModal';
import s from './s.module.less';

const Page = () => {
    const [getUser] = ProviderStore.useStore();
    const [getSubscription] = SubscriptionStore.useStore();
    const user = getUser('data');
    const loadingUser = getUser('loading');
    const loadingPlan = getSubscription('loading');

    const [isExistUser, setIsExistUser] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const _isExistUser = getHasShowCalendarOnboardingPopup240315();
        const _hasShowCurrentVersionPop = getHasShowCalendarOnboardingPopup240415();
        if (_hasShowCurrentVersionPop) {
            setIsExistUser(true);
            setIsModalOpen(false);
        } else if (!_hasShowCurrentVersionPop && _isExistUser) {
            setIsExistUser(true);
            setIsModalOpen(true);
        } else {
            setIsExistUser(false);
            setIsModalOpen(true);
        }

        // setIsExistUser(false);
        // setIsModalOpen(true);
    }, []);

    const handleCloseModal = () => {
        setHasShowCalendarOnboardingPopup240315(true);
        setHasShowCalendarOnboardingPopup240415(true);
        setIsModalOpen(false);
    };

    if (!user || loadingUser || loadingPlan) {
        return <div style={{ padding: 48 }}><LoadingOutlined /></div>;
    }

    return (
        <div className={s.calendarPage}>
            <CalendarManagePage isShowingWelcomeModal={isModalOpen} />
            <WelcomeModal showBackButton={false} isOpen={isModalOpen} isExistUser={isExistUser} onClose={handleCloseModal} />
        </div>
    );
};

export default Page;
